import { render, staticRenderFns } from "./ServerSelection.vue?vue&type=template&id=c3d04764&scoped=true&lang=html"
import script from "./ServerSelection.vue?vue&type=script&lang=js"
export * from "./ServerSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d04764",
  null
  
)

export default component.exports